export default __webpack_public_path__ + "static/media/nova-mensagem-chat-interno.a713dfcf.mp3";